import { useLoader } from '@react-three/fiber';
import { memo } from 'react';
import { TextureLoader } from 'three';

const Sun = () => {
  const texture = useLoader(TextureLoader, '/assets/2.jpg');
  return (
    <mesh position={[0.485, 0.07, -0.06]} layers={1}>
      <sphereGeometry args={[0.07, 32, 32]} />
      <meshBasicMaterial map={texture} toneMapped={false} />
    </mesh>
  );
};

export default memo(Sun);
